module.exports = __webpack_public_path__ + "static/img/bonus_2.2b28907.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dhlw/bonus_2.png
// module id = 3cIF
// module chunks = 0